// extracted by mini-css-extract-plugin
export default {"button":"LegalLinkModal-module_button_d161d3","label":"LegalLinkModal-module_label_b96aa6"};